import React, { useCallback } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import QRCode from "qrcode.react";
import { downloadQrCodeAsSvg } from "../../../../utils/qrCode";

export function PreviewQrDialog({
	visible,
	url,
	onHide,
}: {
	visible: boolean;
	url: string | null;
	onHide: () => void;
}) {
	const handleDownload = useCallback(() => {
		const urlId = url?.split("/").pop();
		if (urlId) {
			downloadQrCodeAsSvg(urlId);
		}
	}, [url]);

	const footer = (
		<div>
			<Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
			<Button label="Download QR Code" icon="pi pi-download" onClick={handleDownload} autoFocus />
		</div>
	);

	return (
		<Dialog header="View QR Code" visible={visible} style={{ width: "30rem" }} onHide={onHide} footer={footer}>
			<div className="flex justify-content-center p-4 px-5" style={{backgroundColor: "#000"}}>
				{url ? (
					<QRCode
						id="qrcode-svg"
						value={url}
						size={370}
						renderAs="svg"
						fgColor="#ffffff"
						bgColor="transparent"
					/>
				) : null}
			</div>
		</Dialog>
	);
}